import { captureGAEvent } from './googleAnalytics';

const CATEGORY = 'Welcome Page';

const ACTIONS = {
  EDIT_WORKFLOW_GEAR_CLICK: 'Edit workflow gear click',
};

const emitEvent = gaEvent => {
  captureGAEvent({ category: CATEGORY, ...gaEvent });
};

// eslint-disable-next-line import/prefer-default-export
export const gaEmitEditWorkflowGearClick = () => {
  emitEvent({ action: ACTIONS.EDIT_WORKFLOW_GEAR_CLICK });
};
